import React from "react";
import PropTypes from "prop-types";

const Spinner = () => {
  return (
    <div className="text-center">
      <div className="spinner-border text-primary m-3">
      </div>
    </div>
  );
};

export default Spinner;

export const SpinnerModal = ({ txt }) => {
  return (
    <div className="border rounded-3 py-1 px-2 mb-5 mx-3 d-flex flex-row justify-content-between align-items-center mt-2">
      <div>
        <span className="fw-bold">Guardando: </span>
        <label className="ms-1">{txt}...</label>
      </div>
      <div style={{ height: "17px", width: "17px", paddingTop: "4px" }} className="spinner-border text-primary">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

SpinnerModal.propTypes = {
  txt: PropTypes.string,
};
